/* eslint-disable linebreak-style */
/* eslint-disable indent */
import React from 'react';

const Hero = () => {
    return (
        <>
        <div className="hero-text"><h1>Ultra Nostalgia</h1></div>
        <div className="hero-wrapper" />
        </>
    )
}

export default Hero;